import { Div2, Span } from "../styled_components/divs";
import t from "../../../helpers/t";
import AvailIcon from "../components/AvailIcon";
import Akkus from "../components/Akkus";
import { rbac } from "../index";
import { moment } from "../../../../../vendor";
import React, { useState } from "react";
import ImageViewer from "../../../components/imgView/ImageView";

const ItemMedium = (props) => {
  const {
    localResource,
    hasResourceNbr,
    showContingentLocationName,
    location_id_name,
    diffString,
    setInitialized,
    switchLock,
    sendSignalSound,
    toggleTheft,
    countOfIcons,
    iconStyle,
    lockPending,
    lockSignalPending,
    lockTheftPending,
    resourcePending,
    onChangeStatus,
    onRemoveResource,
    onGetQRCodeHandler,
    act2,
    note,
    onOpen,
    link,
    index,
    currentUrl,
    facilityName,
  } = props;
  const [currentImage, setCurrentImage] = useState("");

  function returnBlob(blob) {
    setCurrentImage(URL.createObjectURL(blob));
  }

  return (
    <>
      <div
        className={
          "inb-c-item inb-c-item--resource row show-for-medium-only" +
          (localResource.status === "active"
            ? " not-marked"
            : localResource.status === "inactive"
              ? " gray-marked"
              : " red-marked")
        }
        key={"div_row_medium_" + localResource.id}
        style={{ minHeight: "153px" }}
      >
        <div
          className="medium-7 small-7 column inb-order-big padding-1"
          id="order-id"
          title="ID"
          key={"div_resource_id_" + localResource.id}
        >
          <Span>{hasResourceNbr ? localResource.resource_nbr : localResource.id}</Span>
        </div>
        <div
          className="medium-7 small-7 column inb-order-big"
          id="name-bike"
          title="Bezeichnung"
          key={"div_resource_name_" + localResource.id}
        >
          <span className="text-nowrap">{localResource.name}</span>
          <br />
          <div
            title={t("description")}
            style={{ textAlign: "left", fontSize: ".8125rem", fontWeight: "normal" }}
          >
            {note}
          </div>
        </div>
        <div
          className="medium-7 small-7 column"
          id="inb-contingent"
          title="Kontingent"
          key={"div_resource_contingent_" + localResource.id}
        >
          {localResource.contingent_id_name}
          {showContingentLocationName ? " | " + localResource.contingent_id_location_name : ""}
        </div>
        <div className="medium-12 small-12 inb-group-item hide-for-medium-only">
          <div className="medium-6 small-6 column" title="Standort">
            <span
              style={
                localResource.location_id == null || localResource.checkedInStatus === "inprogress"
                  ? { color: "#e54f17" }
                  : {}
              }
            >
              {location_id_name}
            </span>
            <br />
            {link}
            <br />
            {facilityName}
          </div>
          <div className="medium-3 small-3 medium-offset-0 column padding-1" title="Verfügbarkeit">
            <AvailIcon
              Value={diffString !== null ? "pending" : localResource.checkedInStatus}
              Title={
                diffString !== null ? diffString : t(localResource.checkedInStatus, null, "capital")
              }
              Reservation={
                localResource.checkedInStatus === "inprogress" ? localResource.reservation.id : null
              }
              key={"icon_resource_avail_" + localResource.id}
              Resource={localResource.id}
              setInitialized={setInitialized}
            />
            <Div2> {localResource.checkInAmount}</Div2>
          </div>
        </div>

        <div
          className="medium-7 small-7 column show-for-medium-only"
          title="Standort"
          style={
            localResource.location_id == null
              ? { minHeight: "40px", color: "#e54f17" }
              : { minHeight: "40px" }
          }
          key={"div_resource_location_" + localResource.id}
        >
          <span>{location_id_name}</span>
          <br />
          <span>{facilityName} </span>
        </div>
        <div
          className="medium-12 small-12 medium-offset-0 show-for-medium-only row"
          id="group-icon-three"
          title="Akkus"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "initial",
            paddingLeft: "75%",
            width: "100%",
          }}
        >
          <Akkus
            resource={localResource}
            switchLock={switchLock}
            sendSignalSound={sendSignalSound}
            toggleTheft={toggleTheft}
            showPercent={true}
            small={true}
            key={"mobile_akkus_" + localResource.id}
            style={iconStyle}
            lockPending={lockPending}
            lockSignalPending={lockSignalPending}
            lockTheftPending={lockTheftPending}
            locked={lockPending !== null && lockPending?.id === localResource.id}
          />
        </div>
        <div
          className="medium-12 small-12 inb-group-item"
          id="group-item-3"
          key={"div_resource_buttons_group_" + localResource.id}
          style={{ width: "100%" }}
        >
          <div className="medium-12 small-12 medium-offset-0 row" id="inb-group-status-time">
            <div
              className="medium-5 small-5 column"
              id="status"
              title="Status"
              style={{ paddingTop: "17px" }}
            >
              {rbac.hasPermission("editStatus") && (
                <>
                  {resourcePending === null ? (
                    <select
                      className={
                        index % 2 === 1
                          ? "inbooma-select-box__input second-select"
                          : "inbooma-select-box__input"
                      }
                      name="status"
                      onChange={(e) => onChangeStatus(e, localResource)}
                      key={"select_resource_status_" + localResource.id}
                      value={localResource.status === null ? "" : localResource.status}
                      placeholder={t("select_${a}", { a: t("status") })}
                    >
                      {["active", "inactive", "defect"].map((status) => {
                        return (
                          <>
                            <option key={"mobile_" + status + localResource.id} value={status}>
                              {t(status)}
                            </option>
                          </>
                        );
                      })}
                    </select>
                  ) : (
                    <>
                      {" "}
                      <span>
                        <img
                          alt="RollingLoader"
                          className="rollingLoader colorize-black"
                          src={"assets/img/rolling_loader.svg"}
                        />{" "}
                      </span>
                    </>
                  )}
                </>
              )}
              {!rbac.hasPermission("editStatus") && <span>{t(localResource.status)}</span>}
            </div>
            <div className="medium-7 small-7 column datetime-booking" title="Modifiziert am">
              {"Modifiziert am " + moment(localResource.modified).format("DD.MM.YY HH:mm")}
              <br />
              <div style={{ textAlign: "left", paddingTop: "5px" }}>{act2}</div>
            </div>
          </div>
        </div>

        <div
          className="medium-offset-0 column item-button-group padding-05"
          key={"div_resource_edit_" + localResource.id}
        >
          <div className="medium-3 small-3 medium-offset-0 column" id="group-icon-one">
            {rbac.hasPermission("editResource") && (
              <div
                className="button-container-resources left"
                key={"div_resource_button_container_edit_" + localResource.id}
              >
                <a
                  href={"/resources/" + localResource.id + currentUrl.search}
                  title={t("edit")}
                  key={"a_resource_edit_" + localResource.id}
                  data-inb-action-link="edit"
                >
                  <button type="button" className="inb-round-btn hollow round float-left">
                    <div className="inb-fi-edit"> </div>
                  </button>
                </a>
              </div>
            )}
            {rbac.hasPermission("write") && (
              <div
                className="button-container-resources"
                key={"div_resource_button_container_delete_" + localResource.id}
              >
                <a
                  href="src/js/react/pages/resources/viewItems/ItemMedium#"
                  className="inb-reservation__pdf2"
                  title={t("delete")}
                  key={"a_resource_delete_" + localResource.id}
                  data-inb-action-link="delete"
                >
                  <button
                    type="button"
                    className="inb-round-btn hollow round float-left"
                    key={"a_button_resource_delete_" + localResource.id}
                    onClick={() => onRemoveResource(localResource)}
                  >
                    <div className="inb-fi-remove"> </div>
                  </button>
                </a>
              </div>
            )}
            <div
              className="button-container-resources"
              key={"div_resource_button_container_qr_" + localResource.id}
            >
              <a
                href="src/js/react/pages/resources/viewItems/ItemMedium#"
                title={t("getQRCode")}
                key={"a_resource_qr_" + localResource.id}
                data-inb-action-link="delete"
              >
                <button
                  type="button"
                  className="inb-round-btn hollow round float-left"
                  key={"a_button_resource_qr_" + localResource.id}
                  onClick={() => setCurrentImage(onGetQRCodeHandler(localResource, returnBlob))}
                >
                  <div className="inb-fi-qrcode"> </div>
                </button>
              </a>
            </div>
          </div>
          <div
            className="medium-3 small-3 medium-offset-0 column show-for-medium-only"
            id="group-icon-two"
          >
            {link ? <div id="mapIcon">{link}</div> : ""}
            <div title="Verfügbarkeit" id="availCheckedIn">
              <AvailIcon
                Value={localResource.checkedInStatus}
                Title={t(localResource.checkedInStatus, null, "capital")}
                Reservation={
                  localResource.checkedInStatus === "inprogress"
                    ? localResource.reservation.id
                    : null
                }
                key={"icon_resource_avail_" + localResource.id}
                Resource={localResource.id}
                setInitialized={setInitialized}
              />
              {/* <Div2> {localResource.checkInAmount}</Div2>   */}
            </div>
          </div>
        </div>
      </div>
      {currentImage && (
        <ImageViewer
          images={localResource}
          currentImage={currentImage}
          setCurrentImage={setCurrentImage}
        />
      )}
    </>
  );
};

export default ItemMedium;
